/* eslint-disable import/no-unused-modules */
export type CatalogDataItem = {
  label: string
  desc: string
  children: CatalogDataItem[]
}

export type CatalogData = CatalogDataItem[]

export type TreeItem = {
  path: string
  description: string
  id: number | string
  dataTestId?: string
}

export type DialogState = { open: boolean; itemId: string | number | undefined }

export type AlertState = {
  message: string
  visible: boolean
}

export type CatalogLabels = {
  topic: string
  mainColumn: string
  secondaryColumn: string
}

/**
 *
 * Converts a {@link CatalogData} array into a useable {@link TreeItem}[].
 *
 * @param initialData The {@link CatalogData} to be converted.
 * @param path The path of the node currently being converted.
 * @param nodes The {@link TreeItem}[] of nodes that is being updated with each conversion.
 * @returns A list of {@link TreeItem}.
 */
export function convertToDataTree(initialData: CatalogData, path?: string, nodes: TreeItem[] = []): TreeItem[] {
  for (const item of initialData) {
    const itemPath = path ? `${path}/${item.label}` : item.label

    const currentItem: TreeItem = {
      path: itemPath,
      description: item.desc,
      id: crypto.randomUUID(),
    }

    nodes.push(currentItem)

    if (item.children && item.children.length > 0) {
      convertToDataTree(item.children, itemPath, nodes)
    }
  }

  return nodes
}

/**
 *
 * Coverts a list of {@link TreeItem} back to a {@link CatalogData} array.
 *
 * @param tree The {@link TreeItem}[] to be converted back.
 * @returns A {@link CatalogData} generated from the input {@link TreeItem}
 */
// TODO: This functions might be useful in the future, but it is not used at the moment.
// export function revertToInitialStructure(tree: TreeItem[]): CatalogData {
//   const catalog: CatalogData = []

//   tree.forEach((item) => {
//     const pathSegments = item.path.split('/')
//     let currentLevel = catalog

//     pathSegments.forEach((segment, index) => {
//       const existingItem = currentLevel.find((el) => el.desc === segment)

//       if (!existingItem) {
//         const newItem: CatalogDataItem = {
//           label: `${index + 1}`,
//           desc: segment,
//           children: [],
//         }

//         currentLevel.push(newItem)
//         currentLevel = newItem.children
//       } else {
//         currentLevel = existingItem.children
//       }
//     })
//   })

//   return catalog
// }

/**
 *
 * Splits the path and returns the inital path (parent nodes)
 *
 * @param input A path representation of a {@link TreeItem}.
 * @returns The parent nodes of the path.
 */
export function getInitialPath(input?: string) {
  if (!input) {
    return ''
  }

  const parts = input.split('/')

  parts.pop()

  return parts.join('/')
}
